import { is } from "./is";
import { showType } from "./show-type";

const dispatchers = {};

export const dispatch = name => (type, ...args) => {
  let fn = void 0;
  const scopedDispatchers = dispatchers[name] || [];
  const len = scopedDispatchers.length;
  for (let i = 0; i < len; i++) {
    const { predicate, implementation } = scopedDispatchers[i] || [];
    if (predicate(type)) {
      fn = implementation;
      break;
    }
  }

  if (fn === void 0) {
    throw new TypeError(
      `Found no implemementation of method: ${name} for type: ${showType(type)}`
    );
  }

  return fn(type, ...args);
};

dispatch.addMethod = (name, T, implementation) =>
  (dispatchers[name] = (dispatchers[name] || []).concat({
    predicate: type => is(type, T),
    implementation
  }));
